import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "sweetalert2/dist/sweetalert2.min.css";
import "../components/Table/Table.css";
import TopLoader from "../components/Loader/TopLoader";
import "react-responsive-modal/styles.css";
import { toast } from "react-toastify";
import {
  new_checklist,
  new_program
} from "../api/Users";
import { useNavigate } from "react-router-dom";

const LaunchProgram = ({ userData,role }) => {
  const { t } = useTranslation();

  
  const [isLoading, setIsLoading] = useState(false);
  const [photoUrl, setPhotoUrl] = useState(null);

  const [program, setProgram] = useState({
    name: "",
    category: "",
    file: "",
    HM: false,
    WEO: false,
    DWO: false,
    DS: false,
    DD: false,
    // questions: [{ question: "", type: "", custom: "", options: [] }],
  });

  const handleChangeInput = (e, index) => {
    const { name, value, type, files, checked } = e.target;
    if (type !== "file") {
      if (type === "checkbox") {
        if (name === "all") {
          setProgram((prevData) => ({
            ...prevData,
            HM: checked,
            WEO: checked,
            DWO: role === 5 ? prevData.DWO : checked,
            DS: role === 5 || role === 6 ? prevData.DS : checked,
            DD: role === 5 || role === 6 || role === 8 ? prevData.DD : checked,
            [name]: checked,
          }));
        } else {
          setProgram((prevData) => ({ ...prevData, [name]: checked }));
        }
      } else {
        // if (name === "question" || name === "type" || name === "custom") {
        //   const newQuestions = [...program.questions];
        //   newQuestions[index][name] = value;
        //   setProgram((prevData) => ({
        //     ...prevData,
        //     questions: newQuestions,
        //   }));
        // } else {
          setProgram((prevData) => ({ ...prevData, [name]: value }));
        // }
      }
    } else {
      const file = files[0];
      setProgram((prevData) => ({ ...prevData, [name]: file }));
      setPhotoUrl(URL.createObjectURL(file));
    }
  };  

  const navigate = useNavigate();

  const onSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const formData = new FormData();

    formData.append("name", program.name);
    formData.append("file", program.file);
    formData.append("gm_id", userData.data.gm_id);
    formData.append("category", program.category);

    const selectedRoles = [];
    if (program.HM) selectedRoles.push("4");
    if (program.WEO) selectedRoles.push("5");
    if (program.DWO) selectedRoles.push("6");
    if (program.DS) selectedRoles.push("8");
    if (program.DD) selectedRoles.push("11");

    const rolesString = selectedRoles.join(",");
    formData.append("program_access_roles", rolesString);

    // program.questions.forEach((q, qIndex) => {
    //   formData.append(`question_${qIndex}`, q.question);
    //   formData.append(`type_${qIndex}`, q.type);
    //   formData.append(`custom_${qIndex}`, q.custom);
    //   q.options.forEach((option, oIndex) => {
    //     formData.append(`option_${qIndex}_${oIndex}`, option);
    //   });
    // });

    new_program(formData)
      .then((res) => {
        if (res.status === "success") {
          setIsLoading(false);
          toast.success(t(res.message));
          navigate(`/all-programs`);
          setProgram({
            name: "",
            file: "",
            HM: false,
            WEO: false,
            DWO: false,
            DS: false,
            DD: false,
          });
          // setTimeout(() => {
          //   window.location.reload();
          // }, 1000);
        } else {
          toast.error(t(res.message));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleAddOption = (index) => {
    const newQuestions = [...program.questions];
    newQuestions[index].options.push("");
    setProgram((prevNotice) => ({ ...prevNotice, questions: newQuestions }));
  };

  const handleRemoveOption = (qIndex, oIndex) => {
    const newQuestions = [...program.questions];
    newQuestions[qIndex].options.splice(oIndex, 1); // Remove the option at the specified index
    setProgram((prevNotice) => ({ ...prevNotice, questions: newQuestions }));
  };

  const today = new Date().toISOString().split("T")[0];

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-2 px-md-4">
        <div className="my-5 col-12 d-flex justify-content-between align-items-center">
          <h5 className="">{t("Add New Program Details")}</h5>
        </div>

        <form
          onSubmit={(e) => onSubmit(e)}
          id="myform"
          style={{ marginTop: "12px" }}
        >
          <div className="row col-12">
            <div
              className="row col-8 p-3 d-flex justify-content-center"
              style={{ borderRight: "1px solid gray" }}
            >
              {/* <div className="col-md-8">
                <label className="form-label">
                  {t("Checklist Name")}{" "}
                  {<span style={{ color: "red" }}>*</span>}
                </label>
                <input
                  type="text"
                  name="heading"
                  value={program.heading}
                  className="form-control"
                  onChange={handleChangeInput}
                  required
                />
              </div>
              <div className="row mt-3">
                <div className="col-md-6">
                  <label className="form-label">
                    {t("Select Answer Type")}
                    <span className="text-danger"> *</span>
                  </label>
                  <select
                    name="answer"
                    className="common-input form-select"
                    onChange={handleChangeInput}
                    required
                  >
                    <option value="">{t("Select answer type")}</option>
                    <option value="checkbox">{t("Checkbox")}</option>
                    <option value="slider">{t("Slider")}</option>
                    <option value="radio">{t("Radio")}</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label">
                    {t("Custom Input")}
                    <span className="text-danger"> *</span>
                  </label>
                  <select
                    name="custom"
                    className="common-input form-select"
                    onChange={handleChangeInput}
                    required
                  >
                    <option value="">{t("Custom Input")}</option>
                    <option value="checkbox">{t("Yes")}</option>
                    <option value="checkbox">{t("No")}</option>
                  </select>
                </div>
              </div>
              <div className="col-md-12 mt-3">
                <label className="form-label">
                  {t("Question")} {<span style={{ color: "red" }}>*</span>}
                </label>
                <input
                  type="textarea"
                  name="question"
                  value={program.question}
                  className="form-control"
                  onChange={handleChangeInput}
                  required
                />
              </div>
              {program.questions.map((question, qIndex) => (
                <div key={qIndex} className="col-md-12">
                  <div className="row mt-3">
                    <div
                      className="col-md-12"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        <label className="form-label">
                          {t("Options")}{" "}
                          {<span style={{ color: "red" }}>*</span>}
                        </label>
                        {question.options.map((option, oIndex) => (
                          <div key={oIndex} className="input-group mb-3">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Option"
                              value={option}
                              onChange={(e) => handleChangeInput(e, qIndex)}
                            />
                            <button
                              className="btn btn-outline-danger"
                              type="button"
                              onClick={() => handleRemoveOption(qIndex, oIndex)}
                            >
                              
                            </button>
                          </div>
                        ))}
                        <br />
                        <button
                          type="button"
                          className="btn btn-success"
                          onClick={() => handleAddOption(qIndex)}
                        >
                          {t("Add Option")}
                        </button>
                      </div>

                      <div className="col-md-4">
                        <label className="form-label">
                          {t("Upload Photo")}{" "}
                          {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <input
                          type="file"
                          name="photo_file"
                          accept=".jpg, .jpeg, .png"
                          className="form-control"
                          onChange={handlePhotoChange}
                        />
                        {error.photo_file && (
                          <div className="text-danger">{error.photo_file}</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))} */}

              <div className="col-md-6 d-flex justify-content-center align-items-center row">
                {photoUrl === null ? (
                  <div
                    className="border border-4 bg-light d-flex align-items-center justify-content-center rounded text-dark "
                    style={{
                      height: "40vh",
                      width: "40vh",
                    }}
                  >
                    <p style={{ zIndex: "100" }}>Program Image</p>
                  </div>
                ) : (
                  <div
                    className="uploadedPhotoDisplay"
                    style={{
                      height: "40vh",
                      width: "40vh",
                      backgroundImage: `url(${photoUrl})`,
                      backgroundSize: "contain",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                    }}
                  ></div>
                )}
              </div>
              <div className="col-md-6 d-flex justify-content-center row">
                <div className="col-md-12">
                  <label className="form-label">
                    {t("Select Category")}
                    <span className="text-danger"> *</span>
                  </label>
                  <select
                    name="category"
                    className="common-input form-select"
                    onChange={handleChangeInput}
                    required
                  >
                    <option value="">{t("Select Category")}</option>
                    <option value="inspection">{t("Inspection")}</option>
                  </select>
                </div>
                <div className="col-md-12">
                  <label className="form-label">
                    {t("Program Name")}{" "}
                    {<span style={{ color: "red" }}>*</span>}
                  </label>
                  <input
                  
                    type="text"
                    name="name"
                    value={program.heading}
                    className="form-control"
                    onChange={handleChangeInput}
                    required
                  />
                </div>
                <div className="col-12">
                  <label className="form-label text-center">
                    {t("Upload Photo")}{" "}
                    {<span style={{ color: "red" }}>*</span>}
                  </label>
                  <input
                    type="file"
                    name="file"
                    accept=".jpg, .jpeg, .png"
                    className="form-control"
                    onChange={handleChangeInput}
                  />
                </div>
              </div>
            </div>
            <div className="col-4 p-5 pt-3 row">
              <h5 className="col-md-12 d-flex justify-content-between">
                {t("Select For Roles")}:
              </h5>
              <div className="mt-2">
                <div className="row">
                  <div className="col-md-12 d-flex">
                    <label className="form-label m-2 fw-bold">
                      {t("Select All")}:
                    </label>
                    <input
                      className="m-2 largerCheckbox form-check-input"
                      type="checkbox"
                      name="all"
                      checked={program.all}
                      onChange={handleChangeInput}
                    />
                  </div>
                  <div className="col-md-12 d-flex justify-content-between">
                    <label className="form-label m-2">{t("HM")}:</label>
                    <input
                      className="m-2 largerCheckbox form-check-input"
                      type="checkbox"
                      name="HM"
                      checked={program.HM}
                      onChange={handleChangeInput}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 d-flex justify-content-between">
                    <label className="form-label m-2">{t("WEO")}:</label>
                    <input
                      className="m-2 largerCheckbox form-check-input"
                      type="checkbox"
                      name="WEO"
                      checked={program.WEO}
                      onChange={handleChangeInput}
                    />
                  </div>
                </div>
                <div className="row" style={{display: role == 5 ? "none" : "block"}}>
                  <div className="col-md-12 d-flex justify-content-between">
                    <label className="form-label m-2">{t("DWO")}:</label>
                    <input
                      className="m-2 largerCheckbox form-check-input"
                      type="checkbox"
                      name="DWO"
                      checked={program.DWO}
                      onChange={handleChangeInput}
                    />
                  </div>
                </div>
                <div className="row"style={{display: role == 5 || role == 6 ? "none" : "block"}}>
                  <div className="col-md-12 d-flex justify-content-between">
                    <label className="form-label m-2">{t("DS")}:</label>
                    <input
                      className="m-2 largerCheckbox form-check-input"
                      type="checkbox"
                      name="DS"
                      checked={program.DS}
                      onChange={handleChangeInput}
                    />
                  </div>
                </div>
                <div className="row"style={{display: role == 5 || role == 6 || role == 8 ? "none" : "block"}}>
                  <div className="col-md-12 d-flex justify-content-between">
                    <label className="form-label m-2">{t("DD")}:</label>
                    <input
                      className="m-2 largerCheckbox form-check-input"
                      type="checkbox"
                      name="DD"
                      checked={program.DD}
                      onChange={handleChangeInput}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row col-12 mt-5 d-flex justify-content-end">
            <button
              type="submit"
              className="btn btn-primary me-2 col-md-2"
            >
              {t("Add")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default LaunchProgram;
